module.exports = __webpack_public_path__ + "img/custom-item2-1.c62a958.png";